/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class UploadField extends Vue {

    private fileName = 'Choose an apk file'
    private formData : FormData

    private fileChange(fileList: FileList) {
        this.formData = new FormData();
        let num: number = 0
        this.fileName=""
        Array.prototype.forEach.call(fileList, (file: File) => {
            this.formData.append(num.toString(),file,file.name)
            this.fileName += file.name
            num ++
        });
        //for (const file of fileList){
        //    this.formData.append(num.toString(),file,file.name)
        //    this.fileName += file.name
        //    num ++
        //}
        this.$emit('fileChanged',this.formData)
    }
}
